export const SET_CONTENT_LIST = "SET_CONTENT_LIST";
export const SET_PAGINATION_LINKS = "SET_PAGINATION_LINKS";
export const initialState = {
    contentList: [],
    pagination: { next: null },
};
export const setContentList = (contentList) => ({
    type: SET_CONTENT_LIST,
    contentList,
});
export const setPaginationLinks = (pagination) => ({
    type: SET_PAGINATION_LINKS,
    pagination,
});
export const ugcReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_CONTENT_LIST:
            return {
                ...state,
                contentList: [...action.contentList],
            };
        case SET_PAGINATION_LINKS:
            return {
                ...state,
                pagination: { ...action.pagination },
            };
        default:
            return state;
    }
};
